export default __webpack_public_path__ + "static/media/feedbackMobile.de12806e.jpg";